import { useCompaniesStore } from "~/store/companies/companies.store";
import { learningPathIdFromQuery } from "~/utils/helpers/learning-path-query";

/**
 * Named middleware. Guards the participant-facing parcours deep link
 * (`/my-trainings?learning_path_id=…`) behind the company's `learning_paths` flag.
 *
 * Separate from `learning-path-guard.ts`, which forbids the whole admin page when the flag is off:
 * here /my-trainings itself stays perfectly legitimate — only the parcours detail is off-limits, so
 * only that query is refused. A shared or bookmarked link from a company that has the feature must
 * read as "this does not exist" rather than silently opening an empty modal — and so must a malformed
 * one (repeated or empty `learning_path_id`), which no parcours can answer.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (to.query.learning_path_id === undefined) return;

  const notFound = () => createError({ statusCode: 404, statusMessage: "Ce parcours n'existe pas", fatal: true });

  if (!learningPathIdFromQuery(to.query.learning_path_id)) {
    throw notFound();
  }

  const companiesStore = useCompaniesStore();

  // The flag may not be loaded yet on a direct URL load / hard refresh.
  if (!companiesStore.companyInfos) {
    await companiesStore.fetchCompanyInfos();
  }

  if (!companiesStore.companyInfos?.learningPaths) {
    throw notFound();
  }
});
